import { Component, HostBinding, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import axios from 'src/app/Service/axios';

import { OtherService } from 'src/app/Service/other.service';

import { Location } from '@angular/common';

import { NotificationService } from 'src/app/Service/notification.service';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

declare let $: any;

@Component({

  selector: 'device',

  templateUrl: './device.component.html',

})

export class DeviceComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private _location: Location,
    private router: Router,
    private otherService: OtherService,
    private route: ActivatedRoute,
    private notifyService: NotificationService,
    private gurdService: GurdServiceService
  ) {
    this.getItem();

  }

  ngOnInit(): void {

    this.sabtModelGps.disable();

    this.sabtModelGps.controls['strUnitId'].enable();

    if (this.carId != 0 && this.carId != null) {
      this.sabtModelGps.enable();
      // this.sabtModelGps.controls['strUnitId'].disable();
      this.imeIInp = true;
      this.isLoading = false;
    }

  }

  sabtModelGps: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    strUserName: new FormControl(''),

    strPassword: new FormControl(''),

    strRepeatPassword: new FormControl(''),

    iGPS: new FormControl('-1'),

    strCellNo: new FormControl(''),

    strUnitId: new FormControl(''),

  });

  carType: any;

  carImg: any;

  carWork: any;

  gpsType: any;

  selector: boolean = false;

  isLoading: boolean = true;

  carId: number = 0;

  singelCar: any;

  imeIInp: boolean = false;

  getItem = async () => {
    const resp = await axios.post(
      `GetMobileIcon`
    );
    this.carImg = resp.data;

    const resp2 = await axios.post(
      `GetGPSType`
    );
    this.carType = resp2.data;

    const resp3 = await axios.post(
      `GetMobileType`
    );
    this.carWork = resp3.data;

    const resp4 = await axios.post(`GetGPS`);
    this.gpsType = resp4.data;

  };

  goBack() {
    this._location.back();
  }

  sabtGps = async () => {

    var model = this.sabtModelGps.value;

    if (model.iGPS == null || model.iGPS == '' || model.iGPS == -1) {
      this.notifyService.showError('لطفا نوع gps  را وارد کنید');
      return;
    }

    if (model.strPassword && model.strPassword != model.strRepeatPassword) {

      this.notifyService.showError('رمز عبور و تکرار رمز عبور یکسان نیستند');

      return;

    }

    const resp = await axios.post(`AddGPS`, model);

    let res = JSON.parse(resp.data)

    if (res.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      // this.router.navigate(['login']);

      this.router.navigate(['login'], { queryParams: { error: '89' } });


      return;

    }


    if (res == -100) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;
    }

    if (res.iResult == 0) {

      this.notifyService.showError(res.strError);
    }

    else {

      this.notifyService.showSuccess('با موفقیت ثیت شد');

      this.sabtModelGps.patchValue({

        strUserName: "",

        strPassword: "",

        strRepeatPassword: "",

        strCellNo: "",

        strUnitId: "",

      })

      this.sabtModelGps.disable();

      this.sabtModelGps.controls['strUnitId'].enable();

      this.imeIInp = false;
    }

  };

  Imei = async () => {

    var Imei = document.getElementById('Imei') as any;

    if (Imei.value == null || Imei.value == '') {
      this.notifyService.showError('لطفا شناسه را وارد  کنید');
      return;
    }

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

      strUnitID: Imei.value

    }

    const resp = await axios.post(`CheckIMEI`, model);

    let res = JSON.parse(resp.data.toString())

    if (res.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);

      this.router.navigate(['login'], { queryParams: { error: '90' } });

      return;
    }

    if (res.iResult == -2) {
      this.notifyService.showError('این شناسه قبلا استفاده شده است');
    }

    if (res.iResult == 0) {

      return this.notifyService.showError(res.strError);

    }

    if (res.iResult == 1) {

      this.isLoading = false;

      this.sabtModelGps.enable();

      this.imeIInp = true;

      this.notifyService.showSuccess('ثبت خودرو بلا مانع است');
    }

  };

  checkNum(e: any) {
    if (isNaN(e.key)) {
      return false;
    }
    return true;
  }

}
